// 用户管理模块接口
import { get, post, put, deletefn } from "../api/request";
// 用户统计基础信息
export const getStatistics = params => get(`/v1/manager/user/statistics/index`, params)

// 用户统计曲线图
export const getuserMonth = params => get(`/v1/manager/user/statistics/month`, params)

// 用户列表
export const getuserList = params => get(`/v1/manager/user`, params)

// 用户冻结或解冻
export const getuserDeblocking = params => put(`/v1/manager/user/${params}`)

// 用户详情
export const getuserParticulars = params => get(`/v1/manager/user/${params}`)

// 用户邀请列表
export const getuserInviteList = params => get(`/v1/manager/user/invite`, params)

// 用户会员充值
export const getuserMemberRecharge = params => get(`/v1/manager/user/vip`, params)

// 个人订单列表
export const getusermyIndexcharge = params => get(`/v1/manager/collaborate/myIndex`, params)

// 个人收益列表
export const getusermyearnestList = params => get(`/v1/manager/earnest/earnestList`, params)

// 个人消费待反
export const getusermyconsumerRebates = params => get(`/v1/manager/earnest/consumerRebates`, params)

// 个人补贴明细
export const getusermySubsidyList = params => get(`/v1/manager/earnest/subsidyList`, params)
